import Table from "react-bootstrap/Table";
import { FaFilePdf } from "react-icons/fa";

const CustomTable = ({ data = [], coll = [] }) => {
  return (
    <div style={{ width: "100%" }}>
      <div className="table-responsive">
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "black", color: "white" }}>Sr.n.</th>
              {coll.map((item, index) => (
                <th style={{ backgroundColor: "black", color: "white" }} key={index}>
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index} style={{ height: 60 }}>
                <td>{index + 1}</td>
                <td>{item?.name || "-"}</td>
                <td>{item?.email || "-"}</td>
                <td>{item?.phone || "-"}</td>
                <td>{item?.message || "-"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default CustomTable;
